import Vue from "vue";
import VueRouter from "vue-router";
import { auth } from "@/firebase";
import { ClientTable } from "vue-tables-2";
import "vue-toast-notification/dist/theme-default.css";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import "@/../public/css/vue-good-table.css";
Vue.use(VueRouter);
Vue.use(ClientTable);
Vue.use(VueGoodTablePlugin);
const routes = [
  /* LOADING TO - SERVICE WORKER */
  {
    path: "/",
    name: "LoadingTo",
    component: () => import("../views/LoadingTo.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /* LOGIN */
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Usuario/Login.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /* REGISTRARSE */
  {
    path: "/registrarse",
    name: "Registrarse",
    component: () => import("../views/Usuario/Registrarse.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /* RECUPERAR CONTRASEÑA */
  {
    path: "/recuperarpassword",
    name: "RecuperarPassword",
    component: () => import("../views/Usuario/RecuperarPassword.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /* 404 - NOT FOUND */
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/404.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /* INICIO */
  /*{
    path: "/inicio",
    name: "Inicio",
    component: () => import("../views/Inicio.vue"),
    meta: {
      requiereauth: false,
    },
  },*/
  /* MI PERFIL */
  /*{
    path: "/miperfil",
    name: "MiPerfil",
    component: () => import("../views/Usuario/MiPerfil.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* SOPORTE TECNICO */
  /*{
    path: "/soportetecnico",
    name: "SoporteTecnico",
    component: () => import("../views/Usuario/SoporteTecnico.vue"),
    meta: {
      requiereauth: false,
    },
  },*/
  /* BIBLIOTECA */
  /*{
    path: "/biblioteca",
    name: "Biblioteca",
    component: () => import("../views/Biblioteca/Biblioteca.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* LIBROS DIGITALES */
  /*{
    path: "/librosdigitales",
    name: "ListaLibrosDigitales",
    component: () => import("../views/LibrosDigitales/LibrosDigitales.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/librosdigitales/nuevo/:id",
    name: "NuevoLibroDigital",
    component: () => import("../views/LibrosDigitales/NuevoLibro.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/librosdigitales/libro/:id",
    name: "LibroDigital",
    component: () => import("../views/LibrosDigitales/LibroDigital.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/librosdigitales/libro/:idLibro/seccion/:idSeccion",
    name: "LibroDigitalSeccion",
    component: () => import("../views/LibrosDigitales/Seccion.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* COMUNIDAD */
  /*{
    path: "/comunidad",
    name: "Comunidad",
    component: () => import("../views/Comunidad/Comunidad.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/comunidad/publicaciones/reportepublicacion/:id",
    name: "ReportePublicacion",
    component: () =>
      import("../views/Comunidad/Publicaciones/ReportarPublicacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/comunidad/publicaciones/crearpublicacion",
    name: "CrearPublicacion",
    component: () =>
      import("../views/Comunidad/Publicaciones/CrearPublicacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/comunidad/publicaciones/:id",
    name: "Publicacion",
    component: () => import("../views/Comunidad/Publicaciones/Publicacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/comunidad/publicaciones/:id/estadisticas",
    name: "StatsCommunity",
    component: () => import("../views/Desarrollo/StatsCommunity.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/comunidad/publicaciones/editarpublicacion/:id",
    name: "EditarPublicacion",
    component: () =>
      import("../views/Comunidad/Publicaciones/EditarPublicacion.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* EMPRESAS */
  {
    path: "/empresas",
    name: "Empresas",
    component: () => import("../views/Empresas/Empresas.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* NUEVA */
  {
    path: "/empresas/nueva",
    name: "EmpresasNuevaEmpresa",
    component: () => import("../views/Empresas/NuevaEmpresa.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* CONSULTAR */
  /*{
    path: "/empresas/:id",
    name: "Consultar",
    component: () => import("../views/Empresas/Consultar.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* EDITAR */
  {
    path: "/empresas/editar/:id",
    name: "EmpresasEditarEmpresa",
    component: () => import("../views/Empresas/EditarEmpresa.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* PLANES */
  /*{
    path: "/empresas/planes/:id",
    name: "EmpresaPlanes",
    component: () => import("../views/Empresas/Planes/Planes.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* HISTORIAL PLANES */
  /*{
    path: "/empresas/historial/:id",
    name: "Historial",
    component: () => import("../views/Empresas/Planes/HistorialPlanes.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* TRANSACCIONES */
  /*{
    path: "/transacciones/empresas/planes",
    name: "TransaccionesEmpresasPlanes",
    component: () => import("../views/Empresas/Planes/Transacciones.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* MATRIZ LEGAL */
  /*{
    path: "/matrizlegal",
    name: "MatrizLegal",
    component: () => import("../views/MatrizLegal/MatrizLegal.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* CONSULTAR MATRIZ LEGAL  */
  /*{
    path: "/matrizlegal/consultarnorma/:id",
    name: "MatrizLegalConsultar",
    component: () => import("../views/MatrizLegal/ConsultarNorma.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* MATRIZ LEGAL EMPRESA */
  /*{
    path: "/matrizlegal/empresa/:id",
    name: "MatrizLegalEmpresa",
    component: () => import("../views/Empresas/MatrizLegal.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* TEMAS */
  {
    path: "/temas",
    name: "Temas",
    component: () => import("../views/Temas/Temas.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* ASPECTO */
  /*{
    path: "/temas/:idEmpresaSeleccionada/:aspecto",
    name: "TemasNormas",
    component: () => import("../views/Temas/Normas.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* AUTOEVALUACIÓN */
  {
    /* path: "/temas/:idEmpresa/autoevaluacion/:aspecto", */
    path: "/autoevaluacion",
    name: "Autoevaluacion",
    component: () => import("../views/Temas/Autoevaluacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* CUMPLIMIENTO */
  /* {
        path: "/cumplimiento",
        name: "Cumplimiento",
        component: () =>
            import("../views/Cumplimiento/Cumplimiento.vue"),
        meta: {
            requiereauth: true,
        },
    }, */
  /* EMPRESA CUMPLIMIENTO */
  /* {
        path: "/empresacumplimiento",
        name: "EmpresaCumplimiento",
        component: () =>
            import("../views/Cumplimiento/EmpresaCumplimiento.vue"),
        meta: {
            requiereauth: true,
        },
    }, */
  /* MIS CASOS */
  /*{
    path: "/asesorias",
    name: "Asesorias",
    component: () => import("../views/Asesorias/Asesorias.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/asesorias/consultarasesoria/:id",
    name: "ConsultarAsesoria",
    component: () => import("../views/Asesorias/ConsultarAsesoria.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* NOTIFICACIONES */
  /*{
    path: "/notificaciones",
    name: "Notificaciones",
    component: () =>
      import("../views/Usuario/Notificaciones/Notificaciones.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/notificaciones/notificacion/:id",
    name: "Notificacion",
    component: () =>
      import("../views/Usuario/Notificaciones/Notificacion.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* LLAMADAS AGENDADAS */
  /*{
    path: "/llamadasagendadas",
    name: "LlamadasAgendadas",
    component: () => import("../views/Ayuda/LlamadasAgendadas.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* PANEL ADMINISTRATIVO */
  {
    path: "/paneladministrativo",
    name: "PanelAdministrativo",
    component: () => import("../views/Panel/PanelAdministrativo.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/matrizlegal/actividades",
    name: "ActividadesPanel",
    component: () => import("../views/Panel/MatrizLegal/Actividades.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/paneladministrativo/matrizlegal/autoridades",
    name: "AutoridadesPanel",
    component: () => import("../views/Panel/MatrizLegal/Autoridades.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/paneladministrativo/matrizlegal/sectoreseconomicos",
    name: "SectorEconomicoPanel",
    component: () => import("../views/Panel/MatrizLegal/SectorEconomico.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/paneladministrativo/matrizlegal/tipos",
    name: "TiposPanel",
    component: () => import("../views/Panel/MatrizLegal/Tipos.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/paneladministrativo/biblioteca",
    name: "BibliotecaPanel",
    component: () => import("../views/Panel/Biblioteca.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/estadisticas/reportesgsst",
    name: "ReporteSGSSTPanel",
    component: () => import("../views/Panel/Estadisticas/ReporteSGSST.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/empresas",
    name: "EmpresasPanel",
    component: () => import("../views/Panel/Clientes/Empresas/Empresas.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/asesorias",
    name: "AsesoriasPanel",
    component: () => import("../views/Panel/Clientes/Asesorias/Asesorias.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/empresas/temas/:idEmpresa",
    name: "EmpresasTemas",
    component: () =>
      import("../views/Panel/Clientes/Empresas/TemasEmpresa.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/empresas/temas/:idEmpresa/evaluacion/:aspecto",
    name: "EmpresasEvaluacion",
    component: () =>
      import("../views/Panel/Clientes/Empresas/EvaluacionEmpresa.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/usuarios",
    name: "UsuariosPanel",
    component: () => import("../views/Panel/Clientes/Usuarios/Usuarios.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/usuarios/privilegios/:id",
    name: "Privilegios",
    component: () => import("../views/Panel/Clientes/Usuarios/Privilegios.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/clientes/ocupaciones",
    name: "OcupacionesPanel",
    component: () => import("../views/Panel/Clientes/Ocupaciones.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/comunidad/reportes",
    name: "ReportesPanel",
    component: () => import("../views/Panel/Comunidad/Reportes.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/faq/ayuda",
    name: "AyudaPanel",
    component: () => import("../views/Panel/FAQ/Ayuda/Ayuda.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/faq/ayuda/nuevacategoria",
    name: "NuevaCategoria",
    component: () =>
      import("../views/Panel/FAQ/Ayuda/Categorias/NuevaCategoria.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/faq/ayuda/:id",
    name: "ConsultarPreguntas",
    component: () =>
      import("../views/Panel/FAQ/Ayuda/Preguntas/ConsultaPreguntas.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/faq/ayuda/nuevapregunta/:id",
    name: "NuevaPregunta",
    component: () =>
      import("../views/Panel/FAQ/Ayuda/Preguntas/NuevaPregunta.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/matrizlegal/aspectos",
    name: "AspectosPanel",
    component: () => import("../views/Panel/MatrizLegal/Aspectos.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/matrizlegal/aspectos/soportes/:id",
    name: "Soportes",
    component: () => import("../views/Panel/MatrizLegal/Soportes.vue"),
    meta: {
      requiereauth: false,
    },
  },
  {
    path: "/paneladministrativo/notificaciones",
    name: "NotificacionesPanel",
    component: () => import("../views/Panel/Notificaciones/Notificaciones.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/notificaciones/editar/:id",
    name: "EditarNotificacion",
    component: () =>
      import("../views/Panel/Notificaciones/EditarNotificacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/notificaciones/nueva",
    name: "NuevaNotificacion",
    component: () =>
      import("../views/Panel/Notificaciones/NuevaNotificacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/faq/acercade",
    name: "AcercaDePanel",
    component: () => import("../views/Panel/FAQ/AcercaDe.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /*{
    path: "/procesos/pago/:id",
    name: "ProcesarPago",
    component: () => import("../views/Panel/Pagos/Procesar.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/solicitudesopenpay",
    name: "SolicitudesOpenPay",
    component: () => import("../views/Panel/Pagos/Solicitudes.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  {
    path: "/paneladministrativo/pagos/planes",
    name: "PlanesPanel",
    component: () => import("../views/Panel/Pagos/Planes/Planes.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/pagos/planes/nuevo",
    name: "NuevoPlanPagos",
    component: () => import("../views/Panel/Pagos/Planes/NuevoPlan.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/pagos/planes/editar/:id",
    name: "EditarPlanPagos",
    component: () => import("../views/Panel/Pagos/Planes/EditarPlan.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/paneladministrativo/pagos/transacciones",
    name: "TransaccionesPanel",
    component: () => import("../views/Panel/Pagos/Transacciones.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* POLITICA DE COOKIES */
  /*{
    path: "/politicacookies",
    name: "PoliticaCookies",
    component: () => import("../views/Usuario/Politicas/PoliticaCookies.vue"),
    meta: {
      requiereauth: false,
    },
  },*/
  /* POLITICA DE PRIVACIDAD */
  /*{
    path: "/politicaprivacidad",
    name: "PoliticaPrivacidad",
    component: () => import("../views/Usuario/Politicas/PoliticaPrivacidad.vue"),
    meta: {
      requiereauth: false,
    },
  },*/
  /* REPORTE SGSST */
  /*{
    path: "/empresas/:id/reportesgsst",
    name: "ReporteSGSST",
    component: () => import("../views/Empresas/ReporteSGSST/ReporteSGSST.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* NUEVO REPORTE */
  /*{
    path: "/empresas/:idEmpresa/reportesgsst/nuevoreporte/empresa/:idReporte",
    name: "NuevoReporteSGSSTEmpresa",
    component: () => import("../views/Empresas/ReporteSGSST/Empresa.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/empresas/:idEmpresa/reportesgsst/nuevoreporte/representantelegal/:idReporte",
    name: "NuevoReporteSGSSTRL",
    component: () => import("../views/Empresas/ReporteSGSST/RepresentanteLegal.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/empresas/:idEmpresa/reportesgsst/nuevoreporte/encargadosgsst/:idReporte",
    name: "NuevoReporteSGSSTEncargado",
    component: () => import("../views/Empresas/ReporteSGSST/EncargadoSGSST.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/empresas/:idEmpresa/reportesgsst/nuevoreporte/evaluacionestandares/:idReporte",
    name: "NuevoReporteSGSSTEvaluacion",
    component: () => import("../views/Empresas/ReporteSGSST/EvaluacionEstandares.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* CONSULTAR REPORTE */
  /*{
    path: "/empresas/:idEmpresa/reportesgsst/reporte/:idReporte",
    name: "ConsultarReporteSGSST",
    component: () => import("../views/Empresas/ReporteSGSST/ConsultarReporte.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* PLAN DE MEJORA */
  /*{
    path: "/empresas/:idEmpresa/reportesgsst/:idReporte/planmejora/:idPlanMejora",
    name: "PlanMejoraReporteSGSST",
    component: () => import("../views/Empresas/ReporteSGSST/PlanMejora.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /*{
    path: "/reportesgsst/representantelegal/:id",
    name: "RepresentanteLegal",
    component: () => import("../views/ReporteSGSST/RepresentanteLegal.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/reportesgsst/encargado/:id",
    name: "Encargado",
    component: () => import("../views/ReporteSGSST/Encargado.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/reportesgsst/evaluacionestandares/:id",
    name: "EvaluacionEstandares",
    component: () => import("../views/ReporteSGSST/EvaluacionEstandares.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/reportesgsst/planmejora/:id",
    name: "PlanMejora",
    component: () => import("../views/ReporteSGSST/PlanMejora.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/reportesgsst/lista/:id",
    name: "ListaReportes",
    component: () => import("../views/ReporteSGSST/Lista.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/reportesgsst/consulta/:id",
    name: "ConsultarReporte",
    component: () => import("../views/ReporteSGSST/ConsultarReporte.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/reportesgsst/pdf/:id",
    name: "Pdf",
    component: () => import("../views/ReporteSGSST/Pdf.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* PORCENTAJE AUTOEVALUACIÓN */
  /*{
    path: "/percentage",
    name: "Percentage",
    component: () => import("../views/Percentage.vue"),
    meta: {
      requiereauth: false,
    },
  },*/
  /* DESARROLLO */
  /* {
    path: "/cumplimiento",
    name: "Cumplimiento",
    component: () => import("../views/Desarrollo/Cumplimiento.vue"),
    meta: {
      requiereauth: false,
    },
  }, */
  /*{
    path: "/aspecto/:aspecto",
    name: "Aspecto",
    component: () => import("../views/Desarrollo/Aspecto.vue"),
    meta: {
      requiereauth: false,
    },
  },
  {
    path: "/chart",
    name: "Chart",
    component: () => import("../views/Desarrollo/Chart.vue"),
    meta: {
      requiereauth: false,
    },
  },
  {
    path: "/informe",
    name: "Informe",
    component: () => import("../views/Desarrollo/Informe.vue"),
    meta: {
      requiereauth: false,
    },
  },
  {
    path: "/pdf",
    name: "PDF",
    component: () => import("../views/Desarrollo/Pdf.vue"),
    meta: {
      requiereauth: false,
    },
  },
  {
    path: "/ayuda",
    name: "Ayuda",
    component: () => import("../views/Usuario/Ayuda.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /* ASPECTOS */
  {
    path: "/listaaspectos",
    name: "ListaAspectos",
    component: () => import("../views/Desarrollo/ListaAspectos.vue"),
    meta: {
      requiereauth: false,
    },
  },
  /*{
    path: "/dashboard",
    name: "MinTrabajo",
    component: () => import("../views/Desarrollo/MinTrabajo.vue"),
    meta: {
      requiereauth: false,
    },
  },*/
  /*{
    path: "/vinculaciones",
    name: "VinculacionesEmpresa",
    component: () => import("../views/Empresas/Vinculaciones/Vinculaciones.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/vinculaciones/nuevavinculacion",
    name: "NuevaVinculacionEmpresa",
    component: () => import("../views/Empresas/Vinculaciones/NuevaVinculacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/vinculaciones/editarvinculacion/:id",
    name: "EditarVinculacionEmpresa",
    component: () => import("../views/Empresas/Vinculaciones/EditarVinculacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/solicitudesvinculacion",
    name: "SolicitudesVinculacion",
    component: () => import("../views/Usuario/SolicitudesVinculacion/SolicitudesVinculacion.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/solicitudesvinculacion/nuevasolicitud",
    name: "NuevaSolicitudVinculacion",
    component: () => import("../views/Usuario/SolicitudesVinculacion/NuevaSolicitud.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* MINISTERIO */
  /* REPORTE SG-SST */
  /*{
    path: "/ministerio/reportesgsst",
    name: "MinisterioReporteSGSST",
    component: () => import("../views/Ministerio/ReporteSGSST.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* NUEVO REPORTE */
  /*{
    path: "/ministerio/reportesgsst/nuevoreporte/empresa/:id",
    name: "MinisterioNuevoReporteEmpresa",
    component: () => import("../views/Ministerio/ReporteSGSST/Empresa.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/ministerio/reportesgsst/nuevoreporte/representantelegal/:id",
    name: "MinisterioNuevoReporteRL",
    component: () => import("../views/Ministerio/ReporteSGSST/RepresentanteLegal.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/ministerio/reportesgsst/nuevoreporte/encargadosgsst/:id",
    name: "MinisterioNuevoReporteEncargadoSGSST",
    component: () => import("../views/Ministerio/ReporteSGSST/EncargadoSGSST.vue"),
    meta: {
      requiereauth: true,
    },
  },
  {
    path: "/ministerio/reportesgsst/nuevoreporte/evaluacionestandares/:id",
    name: "MinisterioNuevoReporteEvaluacion",
    component: () => import("../views/Ministerio/ReporteSGSST/EvaluacionEstandares.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* CONSULTAR REPORTE */
  /*{
    path: "/ministerio/reportesgsst/reporte/:id",
    name: "MinisterioConsultarReporte",
    component: () => import("../views/Ministerio/ReporteSGSST/ConsultarReporte.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* PLAN DE MEJORA */
  /*{
    path: "/ministerio/reportesgsst/planmejora/:id",
    name: "MinisterioPlanMejora",
    component: () => import("../views/Ministerio/ReporteSGSST/PlanMejora.vue"),
    meta: {
      requiereauth: true,
    },
  },*/
  /* CSV TO JSON */
  {
    path: "/csvtojson",
    name: "CsvToJson",
    component: () => import("../views/CsvToJson.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* DESARROLLO */
  {
    path: "/desarrollo",
    name: "Desarrollo",
    component: () => import("../views/Desarrollo/Desarrollo.vue"),
    meta: {
      requiereauth: true,
    },
  },
  /* MATRIZ LEGAL DEV - ATOMIC DESIGN */
  {
    path: "/matrizlegaldev",
    name: "MatrizLegalDev",
    component: () => import("../views/Desarrollo/MatrizLegalDev.vue"),
    meta: {
      requiereauth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  let usuario = auth.currentUser;
  let requiereAuth = to.matched.some((record) => record.meta.requiereauth);
  // Condicionales de acceso / redireccionamiento
  // Si requiere autentificacion y tiene usuario
  if (requiereAuth && usuario) {
    next();
  }
  // Si requiere autentificacion y no tiene usuario
  else if (requiereAuth && !usuario) {
    next({ name: "Login" });
  }
  // No requiere autentificacion y tiene usuario
  else if (!requiereAuth && usuario) {
    if (to.name === "Login" || to.name === 'Registrarse') {
      next({ name: "MatrizLegalDev" });
    } else {
      next();
    }
  }
  // No requiere autentificacion y no tiene usuario
  else if (!requiereAuth && !usuario) {
    next();
  }
});
export default router;